<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page

========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2 text-center">
              <!-- <span class="mx-auto text-big text-white">RISK VISION</span> -->
              <img src="@/assets/images/pages/login/ribu-logo.png" width="50%" class="mx-auto"/>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container" v-if="!is_enabled_2fa">

                <div class="vx-card__title mb-4 text-center">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div>
                  <vs-input name="email" icon-no-border icon="icon icon-user" icon-pack="feather"
                    label-placeholder="Email" v-model="email" @keyup.enter="onClickLogin" 
                    class="w-full mb-base" />

                  <vs-input type="password" name="password" icon-no-border icon="icon icon-lock"
                    icon-pack="feather" label-placeholder="Password" v-model="password" @keyup.enter="onClickLogin"
                     class="w-full mt-6 mb-base" />

                  <vs-input v-if="is_enabled_2fa" type="number" name="2FA" icon-no-border icon="icon icon-shield"
                    icon-pack="feather" label-placeholder="2FA CODE" v-model="password" @keyup.enter="onClickLogin"
                    class="w-full mt-6 mb-base" />

                  <div class="flex flex-wrap justify-between my-5 hidden">
                    <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                  </div>
                  <vs-button type=""></vs-button>
                  <vs-button  id="login" @click="onClickLogin" class="float-right" color="success">Login</vs-button>


                  <vs-divider>OR</vs-divider>

                  <div class="social-login-buttons flex flex-wrap items-center mt-4">

                    <div class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click.stop="onClickGoogleSign()">
                      <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google"
                        class="text-white h-4 w-4 svg-inline&#45;&#45;fa fa-google fa-w-16" role="img"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512">
                        <path fill=""
                          d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z">
                        </path>
                      </svg>
                      <span class="text-black ml-2">Sign in with google </span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="p-8 login-tabs-container" v-if="is_enabled_2fa">

                <div class="vx-card__title mb-4 text-center">
                  <h4 class="mb-4">Enter your 2-step verification code</h4>
                  <p>A 6-digit code is generated by your phone.</p>
                </div>

                <img src="@/assets/images/pages/login/google-auth.png" alt="Logo" class="mx-auto" width="130">

                <div>

                  <div id="verify-page" class="flex flex-wrap justify-center mb-12 mt-8">
                    <v-otp-input ref="otpInput" input-classes="otp-input" separator="-" :num-inputs="6"
                      :should-auto-focus="true" :is-input-num="true" @on-complete="handleOnComplete" />
                  </div>
                  <!--                  <vs-input-->
                  <!--                      type="number"-->
                  <!--                      name="2FA"-->
                  <!--                      icon-no-border-->
                  <!--                      icon="icon icon-smartphone"-->
                  <!--                      icon-pack="feather"-->
                  <!--                      label-placeholder="6-digit 2-FA security code"-->
                  <!--                      v-model="two_fa_code"-->
                  <!--                      @keyup.enter="onClickVerify2FA"-->
                  <!--                      class="w-full mt-6 mb-base" />-->



                  <div class="flex flex-wrap justify-between my-5">
                    <vx-tooltip title="Invalid token?" color="dark" position="bottom" :text="invalid_token_para">
                      <a class="cursor-pointer">2FA code not working? </a>
                    </vx-tooltip>
                  </div>
                  <!--                  <vs-button  type=""></vs-button>-->
                  <!--                  <vs-button id="login" @click="onClickVerify2FA" class="float-right">Verify</vs-button>-->

                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const AuthRepository = RepositoryFactory.get('auth');
import ErrorMessages from '@/mixins/ErrorMessages'
import SuccessMessage from "@/mixins/SuccessMessage";
import profile from '../../apis/profile'
import axios from '@/axios'
import OtpInput from "@bachdgvn/vue-otp-input";

import {
  mapActions, mapGetters
} from 'vuex'
import Vue from "vue";

export default {
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      two_fa_enabled: false,
      two_fa_code: '',
      login_data: {},
      invalid_token_para: 'If your 2FA tokens are shown as invalid try to time-sync your mobile device. Your time must show correct local time, date and time zone for the authenticator to work properly. Android and Windows phones have an option to correct for time errors inside the Authenticator app properties if you do not wish to sync your clock. iOS devices must be set to use Internet time to make sure the clock is synced properly.'
    }
  },
  components: {
    "v-otp-input": OtpInput
  },
  mounted() {
    this.$vs.loading.close()
  },
  computed: mapGetters(["is_enabled_2fa"]),
  mixins: [ErrorMessages, SuccessMessage],
  watch: {
    is_enabled_2fa: {
      deep: true,
      handler: function (value) {
        if (value) {

        }
      }
    }
  },
  methods: {
    ...mapActions(['login', 'loginAfter2FA']),
    async onClickLogin() {
      try {
        await this.$vs.loading({
          container: '#login',
          scale: 0.45
        })
        await this.login({
          email: this.email,
          password: this.password,
        })
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close('#login > .con-vs-loading')
    },
    async check2FA() {
      try {
        const login_data = (await profile.login({
          email: this.email,
          password: this.password,
        })).data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async handleOnComplete(value) {
      this.two_fa_code = value
      await this.onClickVerify2FA()
    },
    async onClickVerify2FA() {
      await this.$vs.loading({
        container: '#verify-page',
        scale: 0.45
      })
      try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.login_data.token}`
        const { data } = (await profile.verify2FA({ secret: this.two_fa_code }, this.login_data.user.id)).data
        this.showSuccessMessage(data.message)
        await this.loginAfter2FA(this.login_data)
        this.$router.push('/')
      } catch (e) {
        this.convertAndNotifyError(e)
        this.$refs.otpInput.clearInput();
      }
      this.$vs.loading.close('#verify-page > .con-vs-loading')
    },
    async onClickGoogleSign() {
      window.location.href = `${axios.defaults.baseURL}/auth/google`;
    }
  },
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      // background-color: #2E315D;
      border: 1px solid #2E315D;
      color: black;
    }

    .bg-github {
      background-color: #333
    }
  }
}

.otp-input {
  width: 45px;
  height: 45px;
  padding: 2px;
  margin: 0 5px;
  font-size: 25px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;

  &.error {
    border: 1px solid red !important;
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
